module.exports = __webpack_public_path__ + "img/ORG.194c7fb6.png";